import React from 'react';
import { useDispatch } from 'react-redux';
import { addedToCart } from '../redux/cart/actions';
import { decreaseProduct } from '../redux/products/actions';

const ProductCard = ({ item }) => {
  const { name, category, image, price, quantity, id } = item;

  const dispatch = useDispatch();

  const handleCart = (e) => {
    e.preventDefault();
    dispatch(addedToCart(item));
    dispatch(decreaseProduct(id));
  };

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={image} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{name}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button
          className="lws-btnAddToCart"
          onClick={handleCart}
          disabled={quantity === 0}
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
